<div class="filter-top-bar" #filterTopBar>
  <div class="filter-wrapper dropdown">
    <div class="filter-tabs-holder" cdkDropList cdkDropListOrientation="horizontal" (cdkDropListDropped)="drop($event)" [cdkDropListConnectedTo]="[deleteArea]">
      <div *ngFor="let filter of filters" cdkDrag (cdkDragStarted)="isBeingDragged = true" (cdkDragEnded)="isBeingDragged = false">
        <div class="example-custom-placeholder" *cdkDragPlaceholder></div>
        <div class="filter-tab" *ngIf="filter.show">
          <a cdkDragHandle class="dropdown-toggle d-flex justify-content-center align-items-center" role="button" id="filter-{{ filter.filterKey }}"
            data-bs-toggle="dropdown" aria-expanded="false" data-bs-auto-close="outside" [ngClass]="{'active': isFilterActive(filter)}">
            {{ filter.title }}
            <span *ngIf="getPeekForSelectedValues(filter) as peekValue">&nbsp;({{peekValue | truncate: 4}})</span>
          </a>

          <form [formGroup]="form">
            <div *ngIf="filter.filterKey === 'ids'" class="dropdown-menu px-0 py-0_8 rounded-15 bg-neutral-n1"
              attr.aria-labelledby="filter-{{ filter.filterKey }}">
              <div class="mx-10">
                <input type="text" formControlName="ids" class="form-control input" placeholder="Report ID - separate by space"
                  (keydown.enter)="onSubmitClick(filter.filterKey);$event.preventDefault()" />
                <input-errors [control]="form.controls.ids" [service]="validationService"></input-errors>
              </div>
              <hr>
              <div class="d-flex justify-content-end mx-10">
                <button class="btn mr-10" (click)="onClear(filter.filterKey)">Clear</button>
                <button class="btn btn-primary" (click)="onSubmitClick(filter.filterKey)">Submit</button>
              </div>
            </div>

            <div *ngIf="filter.filterKey === 'dateReported'" class="dropdown-menu px-0 py-15 rounded-15 bg-neutral-n1"
              attr.aria-labelledby="filter-{{ filter.filterKey }}">
              <div class="date-filter-drop mx-15">
                <input-search-period type="date" [autoApply]="false" (change)="onChangeDate($event)" [placeholder]="'Date'"></input-search-period>
              </div>
              <hr>
              <div class="d-flex justify-content-end mx-10">
                <button class="btn mr-10" (click)="onClear(filter.filterKey)">Clear</button>
              </div>
            </div>

            <div *ngIf="filter.filterKey === 'testIds'" class="dropdown-menu px-0 py-0_8 rounded-15 bg-neutral-n1"
              attr.aria-labelledby="filter-{{ filter.filterKey }}">
              <div class="mx-10">
                <input type="text" formControlName="testIds" class="form-control input" placeholder="Test ID - separate by space"
                  (keydown.enter)="onSubmitClick(filter.filterKey);$event.preventDefault()" />
                <input-errors [control]="form.controls.testIds" [service]="validationService"></input-errors>
              </div>
              <hr>
              <div class="d-flex justify-content-end mx-10">
                <button class="btn mr-10" (click)="onClear(filter.filterKey)">Clear</button>
                <button class="btn btn-primary" (click)="onSubmitClick(filter.filterKey)">Submit</button>
              </div>
            </div>

            <div *ngIf="filter.filterKey === 'scheduleName'" class="dropdown-menu px-0 py-0_8 rounded-15 bg-neutral-n1"
              attr.aria-labelledby="filter-{{ filter.filterKey }}">
              <div class="mx-10">
                <input type="text" formControlName="scheduleName" class="form-control input"
                  (keydown.enter)="onSubmitClick(filter.filterKey);$event.preventDefault()" />
                <input-errors [control]="form.controls.scheduleName" [service]="validationService"></input-errors>
              </div>
              <hr>
              <div class="d-flex justify-content-end mx-10">
                <button class="btn mr-10" (click)="onClear(filter.filterKey)">Clear</button>
                <button class="btn btn-primary" (click)="onSubmitClick(filter.filterKey)">Submit</button>
              </div>
            </div>

            <div *ngIf="filter.filterKey === 'testNumbers'" class="dropdown-menu px-0 py-0_8 rounded-15 bg-neutral-n1"
              attr.aria-labelledby="filter-{{ filter.filterKey }}">
              <div class="mx-10">
                <input type="text" formControlName="testNumbers" class="form-control input" placeholder="Test numbers - separate by space"
                  (keydown.enter)="onSubmitClick(filter.filterKey);$event.preventDefault()" />
                <input-errors [control]="form.controls.testNumbers" [service]="validationService"></input-errors>
              </div>
              <hr>
              <div class="d-flex justify-content-end mx-10">
                <button class="btn mr-10" (click)="onClear(filter.filterKey)">Clear</button>
                <button class="btn btn-primary" (click)="onSubmitClick(filter.filterKey)">Submit</button>
              </div>
            </div>

            <div *ngIf="filter.filterKey === 'countryNetworks'" class="dropdown-menu px-15 py-10 rounded-15 bg-neutral-n1"
              attr.aria-labelledby="filter-{{ filter.filterKey }}">
              <app-destinations-select (onChange)="onDestinationChange()" [recent]="true"></app-destinations-select>
            </div>

            <div *ngIf="filter.filterKey === 'suppliers'" class="dropdown-menu px-15 py-10 rounded-15 bg-neutral-n1 supplier-dropdown"
              attr.aria-labelledby="filter-{{ filter.filterKey }}">
              <app-routes-select (onChange)="onRouteChange()" [isFilter]="true" [myConnections]="true"></app-routes-select>
            </div>

            <div *ngIf="filter.filterKey === 'reasonForReport'" class="dropdown-menu px-0 py-0_8 rounded-15 bg-neutral-n1"
              attr.aria-labelledby="filter-{{ filter.filterKey }}">
              <div class="mx-10">
                <input type="text" formControlName="reasonForReport" class="form-control input"
                  (keydown.enter)="onSubmitClick(filter.filterKey);$event.preventDefault()" />
                <input-errors [control]="form.controls.reasonForReport" [service]="validationService"></input-errors>
              </div>
              <hr>
              <div class="d-flex justify-content-end mx-10">
                <button class="btn mr-10" (click)="onClear(filter.filterKey)">Clear</button>
                <button class="btn btn-primary" (click)="onSubmitClick(filter.filterKey)">Submit</button>
              </div>
            </div>

          </form>

        </div>
      </div>
    </div>
    <div class="filter-add-btn" *ngIf="shouldAddFilterBeShown()">
      <a role="button" id="add-filter-link" data-bs-toggle="dropdown" aria-expanded="false"><span class="icon-add"></span> Add Filter</a>
      <ul class="dropdown-menu px-0 py-0_8 rounded-15 bg-neutral-n1" attr.aria-labelledby="add-filter-link">
        <ng-container *ngFor="let filter of filters">
          <li *ngIf="!filter.show" class="dropdown-item filter-item px-15 py-10" (click)="onAdditionalFilterClick(filter)">
            <a>{{ filter.title }}</a>
          </li>
        </ng-container>
      </ul>
    </div>

    <div class="v-line"></div>

    <div cdkDropList #deleteArea="cdkDropList" (cdkDropListDropped)="deleteItem($event)">
      <div class="delete-area d-flex justify-content-center align-items-center" (click)="onClearAllFilter()" [ngClass]="{'drag-active': isBeingDragged}">
        <span class="far fa-trash-alt"></span>
        {{isBeingDragged ? 'Remove Filter' : 'Clear Filters'}}
      </div>
    </div>
  </div>

</div>
